import { api } from "@/lib/apiClient";

export type GdTextbausteinBereich = "einleitung" | "schlusstext" | "beide";

export interface GdTextbaustein {
  id: number;
  name: string;
  inhalt: string;
  bereich: GdTextbausteinBereich;
  sort_index: number;
  created_by?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
}

export interface CreateGdTextbausteinPayload {
  name: string;
  inhalt?: string;
  bereich?: GdTextbausteinBereich;
  sort_index?: number;
}

export interface UpdateGdTextbausteinPayload {
  name?: string;
  inhalt?: string;
  bereich?: GdTextbausteinBereich;
  sort_index?: number;
}

export function listGdTextbausteine(
  bereich?: "einleitung" | "schlusstext",
): Promise<GdTextbaustein[]> {
  const params = new URLSearchParams();
  if (bereich) params.set("bereich", bereich);
  const query = params.toString();
  return api.get<GdTextbaustein[]>(`/dokumente/textbausteine${query ? `?${query}` : ""}`);
}

export function createGdTextbaustein(
  payload: CreateGdTextbausteinPayload,
): Promise<GdTextbaustein> {
  return api.post<GdTextbaustein>("/dokumente/textbausteine", payload);
}

export function updateGdTextbaustein(
  id: number,
  payload: UpdateGdTextbausteinPayload,
): Promise<GdTextbaustein> {
  return api.patch<GdTextbaustein>(`/dokumente/textbausteine/${id}`, payload);
}

export function deleteGdTextbaustein(id: number): Promise<{ ok: boolean; id: number }> {
  return api.del<{ ok: boolean; id: number }>(`/dokumente/textbausteine/${id}`);
}

export function reorderGdTextbausteine(
  items: Array<{ id: number; sort_index: number }>,
): Promise<{ ok: boolean }> {
  return api.put<{ ok: boolean }>("/dokumente/textbausteine/sort", { items });
}
